module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAABWUlEQVQ4jdWTTysFURTAf8YrpbAwpZReTPgEZC0LJTsri7ewUTY2SpnIZuIL+ARWSmz827yNneRRyIKpl4WFplB4Cy906oym29zXZefU6Z6555zfPXfuOU2dfUsesAVM4SZ1YA1Ykegkjn6SCkCXgnaASwfcKLAM7ALnWYfAWtSelYMcYMdAGSiaMC9j1x2v+WlzFBokjQNDQLOx/6jrALDqB6HYp0kc7dtgi8C6xbeh6yAwk276QTjtWRLmgGs9vdfQA40p634/cAZM2mAdwB1wC1QNfdcYWatJHEnclTykDfYn+R+wtox9n2kBU9r1+8N0SGu8qC0v8qC2NOYwcJEDC4BX4CSvsiegBNwYPpmI5xw9BMbyRi9t2k3VVKQFtoEFy1Vzxfaa3UDPb0DZykyp6GxOAG+NAH4QSkEj8g9tMJneI2DPsagvYN4Gk7mTVml1hNWSOKp9AyKrTbmz2RI2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai_group.png
// module id = VSuT
// module chunks = 3